import { gql } from '@apollo/client';

export const GET_SUPPORTED_COMMUNITIES = gql`
query SupportedCommunities {
  supportedCommunities {
    supportedOrganisationId
    scope
    name
  }
}`;
